import { render, staticRenderFns } from "./ThemeSvg.vue?vue&type=template&id=20d149c4"
import script from "./ThemeSvg.vue?vue&type=script&lang=js"
export * from "./ThemeSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports